import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    view: String
  }

  navigate(event) {
    const slug = event.target.value
    const suffix = this.viewValue === "compare" ? "/compare" : ""
    window.location.href = slug ? `/${slug}${suffix}` : `/`
  }
}
